import React, { Fragment } from 'react';
import { getRefinedDeliveryEtc } from '../../../app/Helper/DeliveryHelper';

function DeliveryEtcTemplate({ etcData }) {
  return (
    !!etcData.length && (
      <div>
        {etcData.map((item, i) => (
          <Fragment key={item}>
            {i ? <span className="text_bar" /> : null}
            {item}
          </Fragment>
        ))}
      </div>
    )
  );
}

/**
 * 배송 기타정보(택배사명, 책임배송보상 여부, 품절보상 여부, 편의점 픽업배송 여부)
 */
function DeliveryEtc() {
  const refinedData = getRefinedDeliveryEtc(TMON.htStaticData.htDealInfo);

  if (!refinedData) {
    return null;
  }

  const {
    deliveryCorp,
    dutyDeliveryText,
    soldOutText,
    cvsPickupText,
  } = refinedData;

  /**
   * SDLUI-2350 택배사 표기 추가
   * 노출 순서 정의 : 택배사 > 책임배송보상 > 품절 보상 > 편의점 픽업 배송
   */
  const etcData = [deliveryCorp, dutyDeliveryText, soldOutText, cvsPickupText];

  return DeliveryEtcTemplate({
    etcData: etcData.filter(item => !!item),
  });
}

export default DeliveryEtc;
